'use strict';

define(['jquery'], function () {

  var royalSliderPlus = {
    /**
     * Initiation function
     * @param run
     * @param royalSlider
     */
    init: function init(run, royalSlider) {
      if (run === true) {
        return this.functions(royalSlider);
      }
      return false;
    },

    /**
     * Add functions here which will run on initiation
     * @param royalSlider
     */
    functions: function functions(royalSlider) {
      this.controlCheck(royalSlider);
      /* e.g.
       this.function2();
       this.function3();
       this.function4();
       */
    },

    /**
     * Check the number of slides for each widget carousel set on the page
     * @param royalSlider
     */
    controlCheck: function controlCheck(royalSlider) {
      // Loop through types of widgets
      for (var i = 0; i < royalSlider.length; i++) {
        // Loop through individual widgets to check
        for (var count = 0; count < royalSlider[i].length; count++) {
          if (royalSlider[i][count].data.numSlides <= 1) {
            $(royalSlider[i][count].find).find('.rsBullets').hide();
            $(royalSlider[i][count].find).find('.rsArrow').hide();
          }
        }
      }
    }
  };
  return royalSliderPlus;
});
//# sourceMappingURL=royal-slider-plus.js.map
